module.exports = __webpack_public_path__ + "static/media/classicSampleImage.e358c97c.PNG";